import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'

const IconButtonWithToolTip = ({
  children,
  tooltipTitle = '',
  className = '',
  ...rest
}) => {
  return (
    <Tooltip arrow placement="top" title={tooltipTitle}>
      <IconButton className={className} {...rest}>
        {children}
      </IconButton>
    </Tooltip>
  )
}

export default IconButtonWithToolTip
